function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Box, Text, Button } from 'grommet';
import PropTypes from 'prop-types';

// import EmptyImg from './EmptyBoxWithBee.gif';
import EmptyImg from './EmptyBoxWithClouds.svg';
const NoRecordsPlaceholder = ({
  msg,
  textProps,
  boxProps,
  buttonProps,
  children
}) => {
  return /*#__PURE__*/React.createElement(Box, _extends({
    fill: true,
    align: "center",
    justify: "center",
    gap: "medium",
    background: {
      image: `url(${EmptyImg})`,
      opacity: 'strong',
      size: 'contain'
    }
  }, boxProps), /*#__PURE__*/React.createElement(Text, _extends({
    textAlign: "center"
  }, textProps), children || msg), Object.keys(buttonProps).length > 0 ? /*#__PURE__*/React.createElement(Button, buttonProps) : null);
};
NoRecordsPlaceholder.defaultProps = {
  msg: 'No Records Found',
  textProps: {},
  buttonProps: {},
  boxProps: {}
};
NoRecordsPlaceholder.propTypes = {
  msg: PropTypes.string,
  textProps: PropTypes.object,
  buttonProps: PropTypes.object,
  boxProps: PropTypes.object
};
export default NoRecordsPlaceholder;